import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { WalletBalance } from "@modules/+new/core/wallets-balances/domain/entities/wallet-balance.model";
import { Observable } from "rxjs";
import { WalletsBalanceStatus } from "@modules/+new/core/wallets-balances/domain/entities/wallets-balance-status.model";

export interface WalletBalanceState {
	loaded: boolean;
	hasUnconfirmedBalance: boolean;
	fiatWalletsBalances: WalletBalance[];
	cryptoWalletsBalances: WalletBalance[];
}

const initialState: WalletBalanceState = {
	loaded: false,
	hasUnconfirmedBalance: null,
	fiatWalletsBalances: [],
	cryptoWalletsBalances: []
};

@Injectable({
	providedIn: "root"
})
export class WalletsBalancesStateService extends StateService<WalletBalanceState> {
	constructor() {
		super(initialState);
	}

	public selectFiatWallets(): Observable<WalletBalance[]> {
		return this.select((state: WalletBalanceState) => state.fiatWalletsBalances);
	}

	public selectCryptoWallets(): Observable<WalletBalance[]> {
		return this.select((state: WalletBalanceState) => state.cryptoWalletsBalances);
	}

	public selectCryptoWalletsStatus(): Observable<WalletsBalanceStatus> {
		return this.select((state) => ({
			hasUnconfirmedBalance: state.hasUnconfirmedBalance,
			balances: state.cryptoWalletsBalances
		}));
	}

	public selectFiatWalletsStatus(): Observable<WalletsBalanceStatus> {
		return this.select((state) => ({
			hasUnconfirmedBalance: state.hasUnconfirmedBalance,
			balances: state.fiatWalletsBalances
		}));
	}

	public selectWalletsStatus(): Observable<WalletBalanceState> {
		return this.select((state: WalletBalanceState) => state);
	}

	public selectHasUnconfirmedBalance(): Observable<boolean> {
		return this.select((state: WalletBalanceState) => state.hasUnconfirmedBalance);
	}

	public isStateLoaded(): boolean {
		return this.state.loaded;
	}

	public setWallets(balances: Omit<WalletBalanceState, "loaded">): void {
		this.setState({
			loaded: true,
			hasUnconfirmedBalance: balances.hasUnconfirmedBalance,
			fiatWalletsBalances: balances.fiatWalletsBalances,
			cryptoWalletsBalances: balances.cryptoWalletsBalances
		});
	}
}
